import { render, staticRenderFns } from "./TestimonialsReviewsSlides.vue?vue&type=template&id=8abe4fe0&"
import script from "./TestimonialsReviewsSlides.vue?vue&type=script&lang=js&"
export * from "./TestimonialsReviewsSlides.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialsReviewsSlides.vue?vue&type=style&index=0&id=8abe4fe0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports